export const GuideStatuses = {
  COMPLETE: 'complete',
  FAILED: 'failed',
  INCOMPLETE: 'incomplete',
  PENDING: 'pending',
};
